import {
  Collapse,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { EOptionType } from "../../../../../../../interfaces/enums";
import { IMateriale } from "../../../../../../../interfaces/lotto/attributes/models";
import { isFilterAndValueSelected } from "../../../../../../../lib/filters";
import { useAppSelector } from "../../../../../../../store/hooks";
import { IFilterProps } from "../../interfaces";

const i18_PATH = "prodotto.list.filters.";

function MaterialiFilter({ filters, setFilters }: IFilterProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);

  const materialeList = useAppSelector((state) => state.lotto_materiale.list);
  const materialeItems = useAppSelector((state) => state.lotto_materiale.items);

  const list: IMateriale[] = useMemo(
    () =>
      !!materialeList && !!materialeItems
        ? materialeList.map((id) => materialeItems[id])
        : [],
    [materialeList, materialeItems]
  );

  const toggleMateriali = () => {
    setOpen(!open);
  };

  const toggleMaterialeSelected = (item: IMateriale) => {
    if (isFilterAndValueSelected(filters, EOptionType.materiale, item.id)) {
      setFilters(
        filters.filter(
          (opt) =>
            !(
              opt.type === EOptionType.materiale && opt.numericValue === item.id
            )
        )
      );
    } else {
      setFilters([
        ...filters,
        {
          type: EOptionType.materiale,
          numericValue: item.id,
          stringValue: item.nome,
        },
      ]);
    }
  };

  return (
    <>
      <ListItemButton onClick={toggleMateriali}>
        <ListItemIcon>
          <Icon
            className="fa-light fa-object-group"
            sx={{ overflow: "visible" }}
          />
        </ListItemIcon>
        <ListItemText primary={t(`${i18_PATH}Materiale`)} />
        {open ? (
          <Icon
            className="fa-light fa-angle-up"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        ) : (
          <Icon
            className="fa-light fa-angle-down"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List dense={true}>
          {list.map((item) => (
            <ListItemButton
              key={item.id}
              sx={{ display: "flex", pl: 5, pr: 1 }}
              onClick={() => toggleMaterialeSelected(item)}
              selected={isFilterAndValueSelected(
                filters,
                EOptionType.materiale,
                item.id
              )}
            >
              <ListItemText sx={{ flex: 1 }} primary={item.nome} />
              <ListItemIcon sx={{ minWidth: 0 }}>
                {isFilterAndValueSelected(
                  filters,
                  EOptionType.materiale,
                  item.id
                ) && (
                  <Icon
                    className="fa-light fa-check"
                    sx={{ overflow: "visible" }}
                  />
                )}
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}

export default MaterialiFilter;
